import type { UserStatus } from '@mfw/common';

import type { ApiMembershipTermsOfUse } from './termsOfUse.schema';

import { z } from 'zod';

export type Invitation = {
  organizationUserId: string;
  organizationName: string;
  organizationId: string;
  roleKey: string;
  // Present only when this invite carries a RECURRING membership — the
  // acceptor must consent to its Terms of Use before `accept` succeeds
  // (see `InvitationModal`'s pre-accept step).
  pendingRecurringMembership: { userMembershipId: string } | null;
  // 6.10 — set when the organization asks clients to accept its terms on
  // connecting; `accept` is refused without `connectionTouVersionId`.
  connectionTermsOfUse: ApiMembershipTermsOfUse | null;
};

export type ApiInvitation = {
  organizationId: string;
  status: UserStatus;
  tenantId: string;
  userId: string;
  type: string;
  id: string;
};

const InvitationAction = {
  ACCEPT: 'accept',
  REJECT: 'reject',
} as const;

export const InvitationActionEnum = z.enum([
  InvitationAction.ACCEPT,
  InvitationAction.REJECT,
]);

export type InvitationActionType = z.infer<typeof InvitationActionEnum>;
